export interface TerminologyConfig {
  pickups: string;
  pickup: string;
  Pickups: string;
  Pickup: string;
}

export const organizationTerminology: Record<string, TerminologyConfig> = {
  assettech: {
    pickups: "collections",
    pickup: "collection",
    Pickups: "Collections",
    Pickup: "Collection",
  },
  default: {
    pickups: "pickups",
    pickup: "pickup",
    Pickups: "Pickups",
    Pickup: "Pickup",
  },
};

export function getTerminology(organizationId: string | null): TerminologyConfig {
  if (!organizationId) {
    return organizationTerminology.default;
  }
  
  return organizationTerminology[organizationId] || organizationTerminology.default;
}

export function replaceTerminology(text: string, terminology: TerminologyConfig): string {
  let result = text;
  
  // Replace in order of specificity (longer words first)
  result = result.replace(/pickups/gi, terminology.pickups);
  result = result.replace(/pickup/gi, terminology.pickup);
  
  return result;
}
